module.exports = __webpack_public_path__ + "static/media/aminities1.eb1ba541.svg";